module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form-item', {
    attrs: {
      "label": "Alt",
      "error": _vm.errors[_vm.addLanguageSuffix('alt')]
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "Alt"
    },
    model: {
      value: (_vm.form[_vm.addLanguageSuffix('alt')]),
      callback: function($$v) {
        _vm.$set(_vm.form, _vm.addLanguageSuffix('alt'), $$v)
      },
      expression: "form[addLanguageSuffix('alt')]"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Grafika desktop (1160px szerokości)",
      "error": _vm.errors['desktop_image']
    }
  }, [_c('image-input-component', {
    model: {
      value: (_vm.form.desktop_image),
      callback: function($$v) {
        _vm.$set(_vm.form, "desktop_image", $$v)
      },
      expression: "form.desktop_image"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Mapa desktop",
      "error": _vm.errors['desktop_map']
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": _vm.mapPlaceholder
    },
    model: {
      value: (_vm.form.desktop_map),
      callback: function($$v) {
        _vm.$set(_vm.form, "desktop_map", $$v)
      },
      expression: "form.desktop_map"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Grafika tablet (max 1160px szerokości)",
      "error": _vm.errors['tablet_image']
    }
  }, [_c('image-input-component', {
    model: {
      value: (_vm.form.tablet_image),
      callback: function($$v) {
        _vm.$set(_vm.form, "tablet_image", $$v)
      },
      expression: "form.tablet_image"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Mapa desktop",
      "error": _vm.errors['tablet_map']
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": _vm.mapPlaceholder
    },
    model: {
      value: (_vm.form.tablet_map),
      callback: function($$v) {
        _vm.$set(_vm.form, "tablet_map", $$v)
      },
      expression: "form.tablet_map"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Grafika mobile (max 768px)",
      "error": _vm.errors['mobile_image']
    }
  }, [_c('image-input-component', {
    model: {
      value: (_vm.form.mobile_image),
      callback: function($$v) {
        _vm.$set(_vm.form, "mobile_image", $$v)
      },
      expression: "form.mobile_image"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Mapa desktop",
      "error": _vm.errors['mobile_map']
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": _vm.mapPlaceholder
    },
    model: {
      value: (_vm.form.mobile_map),
      callback: function($$v) {
        _vm.$set(_vm.form, "mobile_map", $$v)
      },
      expression: "form.mobile_map"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7da79df0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/forms/LogotypesWidget.vue
// module id = 781
// module chunks = 0